import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { apiURL } from 'gatsby-theme-kn/src/utils/partner_portal_spa'
import useAxiosPartnerPortal from 'gatsby-theme-kn/src/hooks/useAxiosPartnerPortal'
import ModalModule from 'gatsby-theme-kn/src/components/modules/ModalModule'
import useModal from 'gatsby-theme-kn/src/hooks/useModal'
import ModalFittingCalculation from 'gatsby-theme-kn/src/components/modules/ModalFittingCalculation'
import LoadingSpinner from 'gatsby-theme-kn/src/components/modules/LoadingSpinner'

const SapServiceFittingCalculation = () => {
  const { t } = useTranslation()
  const [modalState, setModalState] = useState(false)
  const closeModal = () => {
    setModalState(false)
  }

  // Abholen der PLZ-Bereiche aus dem Partner-Portal
  const { data, loading, error } = useAxiosPartnerPortal(
    apiURL('fitting_calculation'),
    {},
    'get'
  )

  return (
    <>
      <ModalModule
        isOpen={modalState}
        closeModal={closeModal}
        title="Neue Kalkulation"
      >
        <ModalFittingCalculation postalCodes={data} />
      </ModalModule>

      {loading && <LoadingSpinner />}
      {data && (
        <a
          href="#"
          className="btn btn-primary"
          onClick={(e) => {
            e.preventDefault()
            setModalState(true)
          }}
        >
          Jetzt Berechnung starten
        </a>
      )}
    </>
  )
}

export default SapServiceFittingCalculation
